export enum RR_BATCH_TYPE {
  DELETE,
  DOWNLOAD,
  UPDATE,
  CUSTOM,
}
